import { Typography, Box, CircularProgress, TablePagination, TextField, InputAdornment } from "@mui/material";
import React, { useState, useCallback } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { StyledPaper } from "../../customComponents/styled/styledPaper";
import EnhancedTable from "./EnhancedTable";
import { useGetClassesPaginatedQuery } from "../classroom/classApiSlice";

const PER_PAGE = 5;

function StudentList() {
  const [openClassroomId, setOpenClassroomId] = useState(null);
  const [page, setPage] = useState(0);
  const [classSearch, setClassSearch] = useState("");

  const { data, isFetching } = useGetClassesPaginatedQuery({ page: page + 1, per_page: PER_PAGE, q: classSearch });
  const classrooms = data?.classrooms || [];
  const totalCount = data?.pagination?.total_items ?? 0;

  const handleToggle = useCallback((classroomId) => {
    setOpenClassroomId((prev) => (prev === classroomId ? null : classroomId));
  }, []);

  if (isFetching && classrooms.length === 0) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ px: 2, pb: 2 }}>
        <TextField
          size="small"
          fullWidth
          placeholder="Search classes..."
          value={classSearch}
          onChange={(e) => {
            setClassSearch(e.target.value);
            setPage(0);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {classrooms.map((classroom) => (
        <StyledPaper key={classroom.id}>
          <Box className="paperHeader">
            <Typography variant="formHeading">
              {classroom.name} students
            </Typography>
            <Typography variant="formSubHeading" sx={{ textTransform: "none" }}>
              Click on a student to view and modify their information
            </Typography>
          </Box>
          <EnhancedTable
            classroom={classroom}
            isOpen={openClassroomId === classroom.id}
            onToggle={handleToggle}
          />
        </StyledPaper>
      ))}
      {totalCount > PER_PAGE && (
        <TablePagination
          component="div"
          count={totalCount}
          rowsPerPage={PER_PAGE}
          rowsPerPageOptions={[PER_PAGE]}
          page={page}
          onPageChange={(_, newPage) => {
            setPage(newPage);
            setOpenClassroomId(null);
          }}
        />
      )}
    </>
  );
}

export default StudentList;

